import useAppModernisation from "../../hooks/useAppModernisation";
import TemplateMenu from "./Menu";
import ModernResources from "../../features/resources/ModernResources";

/**
 * Router component that switches between app and web resource views
 * based on the current app mode and feature flags
 *
 * Logic:
 * - App mode → TemplateMenu (uses switcher components for individual resources)
 * - Web mode + WEB_MODERNISATION=true → Modern web resources (Phase 2)
 * - Web mode + WEB_MODERNISATION=false → Legacy sidebar menu (ResourceMenu component)
 */
const ResourceRouter = () => {
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();

  if (isAppMode) {
    return <TemplateMenu />;
  }

  if (isWebModernisationEnabled) {
    // Phase 2: Modern web resources
    return <ModernResources />;
  }
};

export default ResourceRouter;
